<!-- components/Parallax.vue -->
<template>
  <div class="pr-t" ref="trigger" :class="{ fw: fitWidth }">
    <div class="pr-el" ref="target" :class="className">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
const { $eventBus, $gsap } = useNuxtApp();

const props = defineProps({
  id: String,
  className: String,
  speed: { type: Number, default: 2 },
  scale: { type: Number, default: 1.1 },
  start: { type: String, default: 'top bottom' },
  end: { type: String, default: 'bottom top' },
  scrub: { type: Boolean, default: true },
  markers: { type: Boolean, default: false },
  fitWidth: { type: Boolean, default: false },
});

const trigger = ref(null);
const target = ref(null);
let ctx;

const { $gsap: gsap } = useNuxtApp();

// useScrollProgress(target, progress => {
//   $gsap.set(target.value, {
//     '--progress': `${mapRange(0, 1, -10, 0, progress) * props.speed}%`,
//   });
// });

const init = () => {
  ctx = gsap.context(() => {
    gsap.fromTo(
      target.value,
      {
        '--progress': `${-10 * props.speed}%`,
      },
      {
        '--progress': `${10 * props.speed}%`,
        ease: 'linear',
        scrollTrigger: {
          trigger: target.value,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          ease: 'linear',
        },
      }
    );
  });
};

const revert = () => {
  if (ctx) {
    ctx.revert();
    ctx = null;
  }
};

onMounted(() => {
  init();
});

onUnmounted(() => {
  revert();
});
</script>

<style lang="scss" scoped>
.pr-t {
  position: relative;
  overflow: hidden;
  width: fit-content;
  will-change: transform;
}

.pr-el {
  transform-origin: center;
  transform: translate3d(0, var(--progress, 0%), 0) scale(1.2);
}
</style>
